import React from 'react';

import type IProduct from 'interfaces/IProduct';
import type { ICheckoutsUrls } from 'scenes/Producer/MyCampaigns';

import AdvancedConfigsUrls from './AdvancedConfigsUrls';
import Atention from './Atention';
import CheckoutLink from './CheckoutLink';
import CheckoutSunLink from './CheckoutSunLink';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
  openUrlCreatorCheckout: (urls: ICheckoutsUrls) => void;
  openTrackerForm: () => void;
}

const CheckoutUrls = ({
  currentProduct,
  currentUserId,
  physicalProductPending,
  openUrlCreatorCheckout,
  openTrackerForm
}: IProps) => {
  return (
    <div className='flex flex-col gap-6 rounded-sm bg-white p-6 shadow-sm max-sm:px-2 max-sm:py-6'>
      <CheckoutLink
        currentProduct={currentProduct}
        currentUserId={currentUserId}
        physicalProductPending={physicalProductPending}
      />
      <CheckoutSunLink
        currentProduct={currentProduct}
        currentUserId={currentUserId}
        physicalProductPending={physicalProductPending}
      />
      <AdvancedConfigsUrls
        currentProduct={currentProduct}
        openTrackerForm={openTrackerForm}
        openUrlCreatorCheckout={openUrlCreatorCheckout}
      />
      <Atention />
    </div>
  );
};

export default CheckoutUrls;
